import { getAgentFee } from './getAgentFee';
import { getClientFee } from './getClientFee';
import { IOffer } from '../../../../types/offer';

export function getFeePrice(offer: IOffer, isAgent: boolean, isDealRentCianAgency: boolean) {
  return isAgent ? getAgentFee(offer) : getClientFee(offer, isDealRentCianAgency);
}
